// extracted by mini-css-extract-plugin
export var table = "_tr-0";